import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../ui/alert-dialog";

interface ConfirmDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Heading, e.g. "Remove support column?". */
  title?: string;
  /** Body copy describing what will be removed. */
  description: string;
  confirmLabel?: string;
  onConfirm: () => void;
  /** Explain-only: no destructive action, just a Close button. */
  blocked?: boolean;
}

/**
 * A small confirmation gate for destructive (remove) actions in the collab
 * wizard. Callers keep the pending action in state and pass it via `onConfirm`;
 * the dialog just renders the yes/no prompt.
 */
export const ConfirmDeleteDialog = ({
  open,
  onOpenChange,
  title = "Remove item?",
  description,
  confirmLabel = "Remove",
  onConfirm,
  blocked = false,
}: ConfirmDeleteDialogProps) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>{blocked ? "Close" : "Cancel"}</AlertDialogCancel>
        {!blocked && (
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-red-600 text-white hover:bg-red-700"
          >
            {confirmLabel}
          </AlertDialogAction>
        )}
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
